export const PROJECT_RATE_MAX_PRICE = 999999999999
export const PROJECT_RATE_MIN_PERCENTAGE = 0
export const PROJECT_RATE_MAX_PERCENTAGE = 100

export function isValidProjectRatePercentage (value) {
  if (value === '' || value === null || value === undefined) return false

  const text = String(value).trim()
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return false

  const percentage = Number(text)
  return Number.isFinite(percentage) &&
    percentage >= PROJECT_RATE_MIN_PERCENTAGE &&
    percentage <= PROJECT_RATE_MAX_PERCENTAGE
}

export function calculateProjectRateCost (billingUnitPrice, percentage) {
  const billingPrice = Number(billingUnitPrice)

  if (!Number.isFinite(billingPrice) ||
      billingPrice < 0 ||
      !Number.isInteger(billingPrice) ||
      billingPrice > PROJECT_RATE_MAX_PRICE ||
      !isValidProjectRatePercentage(percentage)) {
    return null
  }

  const calculated = Math.round(billingPrice * Number(percentage) / 100)
  return calculated <= PROJECT_RATE_MAX_PRICE ? calculated : null
}
